import * as requestFromServer from "./PrivateNoticesCrud";
import { callTypes, privateNoticeSlice } from "./PrivateNoticesSlice";

const {actions} = privateNoticeSlice;

export const getPrivateNotices = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPrivateNotices(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllPrivateNotices = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllPrivateNotices(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getTeachers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeachers(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getParents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getParents(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getFathers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getFathers(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getMothers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getMothers(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudents(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSectionsForNotice = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getSectionsForNotice(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getReceipentTeachers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getReceipentTeachers(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getReceipentParents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getReceipentParents(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getReceipentFathers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getReceipentFathers(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getReceipentMothers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getReceipentMothers(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getReceipentStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getReceipentStudents(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getReceipentSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getReceipentSections(queryParams)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getBranches = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getBranches()
    .then(response => {
      dispatch(actions.filterListFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSections = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSections()
    .then(response => {
      dispatch(actions.filterListFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getCourses = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getCourses()
    .then(response => {
      dispatch(actions.filterListFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getNewPrivateNotice = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .getNewPrivateNotice()
  .then(response => {
    dispatch(actions.privateNoticeFetched(response.data));
  })
  .catch(error => {
      
  });
};

export const getPrivateNotice = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .getPrivateNotice(id)
  .then(response => {
    dispatch(actions.privateNoticeFetched(response.data));
  })
  .catch(error => {
      
  });
};

export const downloadAttachment = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .downloadAttachment(id)
  .then(response => {
    dispatch(actions.actionCompleted());
    return response.data;
  })
  .catch(error => {
    dispatch(actions.actionCompleted());
  });    
};

export const savePrivateNotice = privateNotice => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .savePrivateNotice(privateNotice)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deletePrivateNotices = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deletePrivateNotices(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanListState = () => dispatch => {
  dispatch(actions.listStateCleaned());
}

export const cleanPrivateNoticesState = () => dispatch => {
  dispatch(actions.privateNoticesStateCleaned());
}